import React, { useState, useEffect } from "react";
import "./index.scss";
import { pendingServiceInfoHeaderConfig } from "./config";
import CustomTable from "../../../core/custom-table";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import CustomModal from "../../../core/modal";
import PreviewFormGenerator from "../../../core/preview-form-generator";
import { Box } from "@mui/material";
import { pendingServiceInfoFormConfig } from "./config";
import { getFileNameFromUrl } from "../../../utils";
import CustomButtonComponent from "../../../core/custom-button";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ThumbDownOffAltTwoToneIcon from "@mui/icons-material/ThumbDownOffAltTwoTone";
import moment from "moment";
const PendingServiceBulletins = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 5,
    approvalStatus: "PENDING",
    sortBy: "-createdAt",
  });
  const [viewForm, setViewForm] = useState({
    isOpen: false,
    data: {},
  });
  const clickHandler = (type, data) => {
    if (type === "VIEW") {
      const updatedPlantDetails = data?.plantDetails?.map((ele) => ({
        plantName: ele.plantName,
        cutInDate: ele?.cutInDate?.split("T")[0],
        cutInNumber: ele?.cutInNumber,
      }));
      setViewForm({
        isOpen: true,
        data: {
          ...data,
          releaseDate: moment(data.releaseDate).format("DD/MM/YYYY"),
          oem: data?.oem?.name,
          engineModel: data?.engineModel?.join(", "),
          listNumbers: data?.listNumbers?.join(", "),
          defectCode: `${data?.defectCode?.code}-${data?.defectCode?.description}`,
          plantDetails: updatedPlantDetails,
        },
      });
    }
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SERVICE_BULLETINS}`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res.results.map((ele, index) => ({
            ...ele,
            sNo: index + 1,
          }));
          setData({ ...res, results: result });
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  const updateFormStatus = (status) => {
    const { id } = viewForm.data;
    if (id) {
      invokeApi(
        HTTP_METHODS.PUT,
        `${HOSTNAME}${REST_URLS.SERVICE_BULLETINS}/approve-si/${id}`,
        {
          approvalStatus: status,
        }
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("Updated Sucessfully");
            setViewForm({
              isOpen: false,
              data: {},
            });
            loadData(filters);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Pending Requests</p>
        <p className="section-name">Service Bulletins</p>
      </div>
      <div className="si-hide-mobile">
        <CustomTable
          header={pendingServiceInfoHeaderConfig}
          data={data.results || []}
          pageCount={data.totalPages}
          onClick={clickHandler}
          filters={filters}
          onChange={(page) => {
            setFilters({
              ...filters,
              page,
            });
            loadData({
              ...filters,
              page,
            });
          }}
          isLoading={isLoading}
        />
      </div>
      {viewForm?.isOpen && (
        <CustomModal
          title="Service Bulletins"
          onClose={() => {
            setViewForm({
              isOpen: false,
              data: {},
            });
          }}
          contentClassName="pending-model"
        >
          {viewForm?.data?.approvalStatus === "PENDING" && (
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <CustomButtonComponent
                variant="contained"
                color="success"
                sx={{ mr: 1 }}
                onClick={() => updateFormStatus("APPROVED")}
                startIcon={<ThumbUpAltTwoToneIcon />}
              >
                Approve
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="error"
                sx={{ ml: 1, mr: 3 }}
                onClick={() => updateFormStatus("REJECTED")}
                startIcon={<ThumbDownOffAltTwoToneIcon />}
              >
                Reject
              </CustomButtonComponent>
            </Box>
          )}

          <PreviewFormGenerator
            formConfig={pendingServiceInfoFormConfig(true)}
            formValues={viewForm.data}
          />
          <p> Plant Details</p>

          <div className="ph-table" style={{ width: "100%" }}>
            {viewForm?.data?.plantDetails.length > 0 && (
              <div className="pht-header table-header-bg primary-text pending-plant-details-row">
                <span>Plant Name</span>
                <span>Cut In Date</span>
                <span>Cut In Number</span>
              </div>
            )}
            {viewForm?.data?.plantDetails?.map((item, index) => {
              return (
                <div
                  className="pht-header pending-plant-details-row"
                  key={index}
                >
                  <span style={{ marginBottom: "0.5rem" }}>
                    {item.plantName}
                  </span>
                  <span>{item.cutInDate}</span>
                  <span>{item.cutInNumber}</span>
                </div>
              );
            })}
          </div>
          {viewForm?.data?.attachments?.map((r, index) => {
            return (
              <div key={r.blobName + index}>
                {r.blobName ? (
                  <span>{r.blobName}</span>
                ) : (
                  <a href={r} target="_blank">
                    {getFileNameFromUrl(r)}
                  </a>
                )}
              </div>
            );
          })}
        </CustomModal>
      )}
    </div>
  );
};

export default PendingServiceBulletins;
